import { ParsedUrlQuery } from 'querystring';

export function getIsSharedOwnership(query: ParsedUrlQuery) {
    if (query['is_shared_ownership']) {
        return query['is_shared_ownership'];
    }

    return '';
}
